<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <ng-container *ngIf="user; else userSectionLoading">
      <section id="account-settings" class="row" *ngIf="user">
        <div class="col-4">
          <div class="card user">
            <div class="card-body">
              <div class="d-block mx-auto">
                <img
                  loading="lazy"
                  [src]="user.picture || 'assets/images/icons/user.png'"
                  class="rounded user-picture d-block mx-auto"
                  alt="profile image"
                />
                <p class="text-center user-name my-1">
                  {{ user.first_name }} {{ user.last_name }}
                </p>
                <div class="user-roles d-flex justify-content-center">
                  <small
                    *ngFor="let role of user.roles"
                    class="font-weight-bold bg-primary-transparent text-primary user-role rounded"
                    >{{ role.name }}</small
                  >
                </div>
                <!-- <div class="media-body mt-75 ml-1">
                  <button
                    (click)="file.click()"
                    for="account-upload"
                    class="btn btn-sm btn-primary mb-75 mr-75"
                    rippleEffect
                  >
                    Modifier
                  </button>
                  <input
                    type="file"
                    #file
                    id="account-upload"
                    hidden
                    accept="image/*"
                    (change)="uploadImage($event)"
                  />
                  <p>JPG et PNG autorisé. 800kB max</p>
                </div> -->
              </div>
              <div class="user-information mt-2">
                <h3 class="user-information--title">
                  {{ "USER_INFORMATION.TITLE" | translate }}
                </h3>
                <hr />
                <div class="user-information--content">
                  <p>
                    <strong>{{ "USER_INFORMATION.NAME" | translate }}: </strong
                    >{{ user.first_name }}
                    {{ user.last_name }}
                  </p>
                  <p>
                    <strong>{{ "USER_INFORMATION.MAIL" | translate }}: </strong
                    >{{
                      user.email
                        ? user.email
                        : ("USER_INFORMATION.UNDEFINED_FIELD_F" | translate)
                    }}
                  </p>
                  <p>
                    <strong>{{ "USER_INFORMATION.PHONE" | translate }}: </strong
                    >{{
                      user.phone
                        ? user.phone
                        : ("USER_INFORMATION.UNDEFINED_FIELD_M" | translate)
                    }}
                  </p>
                  <p>
                    <strong
                      >{{ "USER_INFORMATION.COMPANY" | translate }}: </strong
                    >{{
                      user.society
                        ? user.society
                        : ("USER_INFORMATION.UNDEFINED_FIELD_F" | translate)
                    }}
                  </p>
                  <p>
                    <strong>{{ "USER_INFORMATION.JOB" | translate }}: </strong
                    >{{
                      user.function
                        ? user.function
                        : ("USER_INFORMATION.UNDEFINED_FIELD_M" | translate)
                    }}
                  </p>
                  <!-- <p>
                    <strong
                      >{{
                        "USER_INFORMATION.REFERENTIEL" | translate
                      }}: </strong
                    >{{
                      user.repository && user.repository != "null"
                        ? repositories[user.repository]
                        : ("USER_INFORMATION.UNDEFINED_FIELD_F" | translate)
                    }}
                  </p> -->
                </div>

                <button
                  class="btn btn-primary rounded mx-auto d-block mt-2"
                  (click)="toggleUserModal()"
                  rippleEffect
                >
                  {{ "USER_INFORMATION.EDIT_BUTTON" | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="card plan-card border-primary">
            <div class="card-body position-relative">
              <div class="badge badge-light-primary">
                {{ "PLAN.BADGE.BASIC" | translate }}
              </div>
              <div
                class="plan-card--price p-1 d-flex align-items-end position-absolute"
              >
                <p class="text-primary position-relative mb-0">
                  <span class="display-4 font-weight-bolder">99</span
                  ><span class="position-absolute">€</span>
                </p>
                <p class="mb-0">/ {{ "PLAN.MONTH" | translate }}</p>
              </div>
              <ul class="pl-1 mt-1 mb-2">
                <li>
                  <span class="align-middle"
                    >10 {{ "PLAN.USERS" | translate }}</span
                  >
                </li>
                <li class="my-25">
                  <span class="align-middle">{{
                    "PLAN.STORAGE" | translate
                  }}</span>
                </li>
                <li>
                  <span class="align-middle">{{
                    "PLAN.SUPPORT" | translate
                  }}</span>
                </li>
              </ul>
              <div>
                <div class="d-flex justify-content-between">
                  <p class="font-weight-bold">{{ "PLAN.DAYS" | translate }}</p>
                  <p class="font-weight-bold">
                    4 / 30 {{ "PLAN.DAYS" | translate }}
                  </p>
                </div>

                <div class="progress-wrapper">
                  <ngb-progressbar
                    type="primary"
                    [value]="87"
                  ></ngb-progressbar>
                  <p class="mt-1 mb-2">4 {{ "PLAN.DAYS_LEFT" | translate }}</p>
                </div>
              </div>
              <button
                (click)="togglePricingPlansModal()"
                class="btn btn-primary text-center btn-block"
                rippleEffect
              >
                {{ "PLAN.UPGRADE_PLAN" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-8 nav-vertical pr-0">
          <div>
            <ul
              ngbNav
              #navVertical="ngbNav"
              [(activeId)]="activeId"
              class="nav nav-pills d-flex w-100 nav-left pl-1"
            >
              <li class="nav-item" [ngbNavItem]="1">
                <a
                  ngbNavLink
                  class="nav-link d-flex py-75"
                  id="account-pill-general"
                  data-toggle="pill"
                  href="#account-vertical-general"
                  aria-expanded="true"
                >
                  <i data-feather="user" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{
                    "GENERAL.TITLE" | translate
                  }}</span>
                </a>
                <ng-template ngbNavContent>
                  <app-general [paymentCards]="paymentCards"></app-general>
                </ng-template>
              </li>

              <li class="nav-item" [ngbNavItem]="2">
                <a
                  ngbNavLink
                  class="nav-link d-flex py-75"
                  id="account-pill-general"
                  data-toggle="pill"
                  href="#account-vertical-password"
                  aria-expanded="true"
                >
                  <i data-feather="lock" class="font-medium-3 mr-1"></i>
                  <span class="font-weight-bold">{{
                    "SECURITY.TITLE" | translate
                  }}</span>
                </a>
                <ng-template ngbNavContent>
                  <app-security></app-security>
                </ng-template>
              </li>
            </ul>
          </div>
          <div [ngbNavOutlet]="navVertical" class="col-12"></div>
        </div>
      </section>
    </ng-container>

    <ng-template #userSectionLoading>
      <div class="d-flex justify-content-center h-100 w-100 my-1">
        <div class="spinner-border" role="status" aria-hidden="true"></div>
      </div>
    </ng-template>

    <div
      *ngIf="showUserModal"
      class="user-modal position-fixed w-100 h-100 modal"
      [ngClass]="{ show: showUserModal, 'custom-fade-out': fadeoutUserModal }"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form
            class="validate-form"
            [formGroup]="editUserDetails"
            (ngSubmit)="updateUserDetails()"
          >
            <div class="modal-header bg-white">
              <button
                type="button"
                class="close"
                (click)="toggleUserModal()"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body mx-2">
              <h3 class="user-modal--title">
                {{ "USER_INFORMATION.MODAL.TITLE" | translate }}
              </h3>

              <div class="form-row d-flex justify-content-between m-0">
                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="first_name">{{
                    "USER_INFORMATION.MODAL.FIRST_NAME" | translate
                  }}</label>
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_NAME' | translate
                    "
                    formControlName="first_name"
                  />
                  <small *ngIf="formErrors['first_name']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>

                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="last_name">{{
                    "USER_INFORMATION.MODAL.LAST_NAME" | translate
                  }}</label>
                  <input
                    type="text"
                    name="last_name"
                    id="last_name"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_NAME' | translate
                    "
                    formControlName="last_name"
                  />
                  <small *ngIf="formErrors['last_name']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>
              </div>

              <div class="form-row d-flex justify-content-between m-0">
                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="email">{{
                    "USER_INFORMATION.MAIL" | translate
                  }}</label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_MAIL' | translate
                    "
                    formControlName="email"
                  />
                  <small *ngIf="formErrors['email']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>

                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="phone">{{
                    "USER_INFORMATION.PHONE" | translate
                  }}</label>
                  <input
                    type="text"
                    name="phone"
                    id="phone"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_PHONE' | translate
                    "
                    formControlName="phone"
                  />
                  <small *ngIf="formErrors['phone']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>

                <!-- <div class="form-group col-6 mr-n1 pr-1">
                  <label for="company">{{
                    "USER_INFORMATION.COMPANY" | translate
                  }}</label>
                  <input
                    type="text"
                    name="company"
                    id="company"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_COMPANY' | translate
                    "
                    [value]="user.society"
                    disabled
                  />
                  <small *ngIf="formErrors['society']" class="text-danger">{{ "USER_INFORMATION.MODAL.ERROR" | translate }}</small>
                </div> -->
              </div>

              <div class="form-row d-flex justify-content-between m-0">
                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="function">{{
                    "USER_INFORMATION.JOB" | translate
                  }}</label>
                  <input
                    type="text"
                    name="function"
                    id="function"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_JOB' | translate
                    "
                    formControlName="function"
                  />
                  <small *ngIf="formErrors['function']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>

                <div class="form-group col-6 mr-n1 pr-1">
                  <label for="referentiel">{{
                    "USER_INFORMATION.REFERENTIEL" | translate
                  }}</label>
                  <select
                    name="referentiel"
                    id="referentiel"
                    class="form-control"
                    [placeholder]="
                      'USER_INFORMATION.MODAL.DEFAULT_REFERENTIEL' | translate
                    "
                    formControlName="repository"
                  >
                    <option
                      default
                      [disabled]="user.repository && user.repository !== 'null'"
                      value="null"
                    >
                      {{ "USER_INFORMATION.UNDEFINED_FIELD_F" | translate }}
                    </option>
                    <option value="1">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.ANSSI" | translate
                      }}
                    </option>
                    <option [disabled]="!userIsPremium" value="2">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.ISO_27001"
                          | translate
                      }}
                    </option>
                    <option [disabled]="!userIsPremium" value="3">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.CMMC" | translate
                      }}
                    </option>
                    <option [disabled]="!userIsPremium" value="4">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.AIRCYBER"
                          | translate
                      }}
                    </option>
                    <option [disabled]="!userIsPremium" value="5">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.PCI_DSS"
                          | translate
                      }}
                    </option>
                    <option [disabled]="!userIsPremium" value="6">
                      {{
                        "USER_INFORMATION.MODAL.REFERENTIELS.PGSSI_S"
                          | translate
                      }}
                    </option>
                  </select>
                  <small *ngIf="formErrors['repository']" class="text-danger">{{
                    "USER_INFORMATION.MODAL.ERROR" | translate
                  }}</small>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-center border-0">
              <button
                type="button"
                class="btn btn-outline-primary mr-1"
                data-dismiss="modal"
                (click)="toggleUserModal()"
              >
                {{ "USER_INFORMATION.MODAL.CANCEL_BUTTON" | translate }}
              </button>
              <button class="btn btn-primary" [disabled]="modalLoadingButton">
                <span
                  *ngIf="modalLoadingButton"
                  class="spinner-border spinner-border-sm mr-1"
                ></span
                >{{ "USER_INFORMATION.MODAL.EDIT_BUTTON" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div (click)="toggleUserModal()" class="modal-backdrop"></div>
    </div>

    <div
      *ngIf="showPricingPlansModal"
      class="pricing-plans-modal position-fixed w-100 h-100 modal"
      [ngClass]="{
        show: showPricingPlansModal,
        'custom-fade-out': fadeoutPricingPlansModal
      }"
      role="dialog"
    >
      <div class="modal-dialog bg-white px-5 py-1 rounded w-75">
        <div class="modal-header bg-transparent mt-n2 mr-n5">
          <button
            type="button"
            class="close"
            (click)="togglePricingPlansModal()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <section id="pricing-plan">
          <!-- title text and switch button -->
          <div class="text-center">
            <h1 class="mt-5">Pricing Plans</h1>
            <p class="mb-2 pb-75">
              Tous les plans comprennent plus de 40 outils et fonctionnalités
              avancés pour dynamiser votre produit. Choisissez le plan le mieux
              adapté à vos besoins.
            </p>
            <!-- <div class="d-flex align-items-center justify-content-center mb-5 pb-50">
              <h6 class="mr-1 mb-0">Monthly</h6>
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  [checked]="Monthly"
                  [(ngModel)]="Monthly"
                  class="custom-control-input"
                  id="priceSwitch"
                  name="priceSwitch"
                />
                <label class="custom-control-label" for="priceSwitch"></label>
              </div>
              <h6 class="ml-50 mb-0">Annually</h6>
            </div> -->
          </div>
          <!--/ title text and switch button -->

          <!-- pricing plan cards -->
          <div class="row pricing-card">
            <div
              class="col-12 col-sm-offset-2 col-sm-10 col-md-12 col-lg-offset-2 col-lg-10 mx-auto"
            >
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="card enterprise-pricing text-center">
                    <div class="card-body">
                      <img
                        src="assets/images/illustration/Pot3.svg"
                        class="mb-2"
                        alt="svg img"
                      />
                      <h3>Basic</h3>
                      <p class="card-text">A simple start for everyone</p>
                      <div class="annual-plan">
                        <div class="plan-price mt-2">
                          <span
                            class="pricing-enterprise-value font-weight-bolder text-primary display-4"
                            >149</span
                          >
                          <sup
                            class="font-medium-1 font-weight-bold text-primary"
                            >€</sup
                          >
                          <sub
                            class="pricing-duration text-body font-medium-1 font-weight-bold"
                            >/ mois</sub
                          >
                        </div>
                      </div>
                      <ul class="list-group list-group-circle text-left">
                        <li
                          class="list-group-item"
                          *ngFor="let enterprisePlanRef of planBenefits"
                        >
                          {{ enterprisePlanRef }}
                        </li>
                      </ul>
                      <button
                        class="btn btn-block btn-outline-success user-select-none mt-2"
                        rippleEffect
                      >
                        Votre plan
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="card standard-pricing popular text-center">
                    <div class="card-body">
                      <div class="pricing-badge text-right">
                        <div class="badge badge-pill badge-light-primary">
                          Populaire
                        </div>
                      </div>
                      <img
                        src="assets/images/illustration/Pot2.svg"
                        class="mb-1"
                        alt="svg img"
                      />
                      <h3>Standard</h3>
                      <p class="card-text">
                        Solution pour les grandes organisations
                      </p>
                      <div class="annual-plan">
                        <div class="plan-price mt-2">
                          <span
                            class="pricing-enterprise-value font-weight-bolder text-primary display-4"
                            >99</span
                          >
                          <sup
                            class="font-medium-1 font-weight-bold text-primary"
                            >€</sup
                          >
                          <sub
                            class="pricing-duration text-body font-medium-1 font-weight-bold"
                            >/ mois</sub
                          >
                        </div>
                      </div>
                      <ul class="list-group list-group-circle text-left">
                        <li
                          class="list-group-item"
                          *ngFor="let standardPlanRef of planBenefits"
                        >
                          {{ standardPlanRef }}
                        </li>
                      </ul>
                      <button
                        class="btn btn-block btn-primary mt-2"
                        rippleEffect
                      >
                        Changer de plan
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--/ pricing plan cards -->

          <!-- pricing free trial -->
          <!-- <div class="pricing-free-trial">
            <div class="row">
              <div class="col-12 col-lg-10 col-lg-offset-3 mx-auto">
                <div class="pricing-trial-content d-flex justify-content-between">
                  <div class="text-center text-md-left mt-3">
                    <h3 class="text-primary">Still not convinced? Start with a 14-day FREE trial!</h3>
                    <h5>You will get full access to with all the features for 14 days.</h5>
                    <button class="btn btn-primary mt-2 mt-lg-3" rippleEffect>Start 14-day FREE trial</button>
                  </div>
    
                  <img
                    src="assets/images/illustration/pricing-Illustration.svg"
                    class="pricing-trial-img img-fluid"
                    alt="svg img"
                  />
                </div>
              </div>
            </div>
          </div> -->
          <!--/ pricing free trial -->

          <!-- pricing faq -->
          <!-- <div class="pricing-faq">
            <h3 class="text-center">FAQ's</h3>
            <p class="text-center">Let us help answer the most common questions.</p>
            <div class="row my-2">
              <div class="col-12 col-lg-10 col-lg-offset-2 mx-auto">
                <div class="accordion collapse-margin collapse-icon">
                  <ngb-accordion [destroyOnHide]="false" [closeOthers]="true">
                    <ngb-panel
                      id="deliveryId{{ i }}"
                      [cardClass]="'collapse-margin'"
                      *ngFor="let qandARef of data.pricing.qandA; let i = index"
                    >
                      <ng-template ngbPanelTitle>
                        <span>{{ qandARef.question }}</span>
                      </ng-template>
                      <ng-template ngbPanelContent>
                        {{ qandARef.ans }}
                      </ng-template>
                    </ngb-panel>
                  </ngb-accordion>
                </div>
              </div>
            </div>
          </div> -->
          <!--/ pricing faq -->
        </section>
      </div>

      <div class="modal-backdrop" (click)="togglePricingPlansModal()"></div>
    </div>
  </div>
</div>
